/**
 * Viral content categories for the Reels creator (VP-100).
 *
 * Single source of truth for the stable category ids shared between the client
 * (renders the picker grid + localized copy via i18n keys) and the server
 * (validates the id and injects the per-category guided-interview directive).
 *
 * IMPORTANT: this module holds ONLY ids — no user-facing copy and no AI prompt
 * text. Client labels live under `chatInterface.reelCreator.categories.*` in the
 * locale JSONs; the interview/skeleton prompt text lives in
 * `server/prompts/reel-categories.prompt.ts` (per CLAUDE.md §3).
 */

export const REEL_CATEGORY_IDS = [
  "product-promo",
  "educational-reel",
  "entertaining-relatable",
  "problem-solution",
  "social-proof-case",
  "behind-the-scenes",
  "limited-time-offer",
] as const;

export type ReelCategoryId = (typeof REEL_CATEGORY_IDS)[number];

export function isReelCategoryId(value: unknown): value is ReelCategoryId {
  return typeof value === "string" && (REEL_CATEGORY_IDS as readonly string[]).includes(value);
}
